import React from "react";

const DirectDebitGuarantee: React.FC = () => {

  return (
    <>
      <div className="row">
        <div className="ddGuarantee box clearfix">
          <div className="large-12 columns">
            <p>The Royal Botanic Gardens, Kew will set up a Direct Debit from the account detailed in this instruction subject to the safeguards assured by the Direct Debit Guarantee.</p>
            <span className="icon-dd-logo"></span>
            <h2 className="dd">The Direct Debit Guarantee</h2>
            <ul className="list">
              <li>This Guarantee is offered by all banks and building societies that accept instructions to pay Direct Debits.</li>
              <li>If there are any changes to the amount, date or frequency of your Direct Debit Royal Botanic Gardens, Kew will notify you 10 working days in advance of your account being debited or as otherwise agreed. If you request Royal Botanic Gardens, Kew to collect a payment, confirmation of the amount and date will be given to you at the time of the request.</li>
              <li>If an error is made in the payment of your Direct Debit by Royal Botanic Gardens, Kew or your bank or building society you are entitled to a full and immediate refund of the amount paid from your bank or building society.</li>
              <li>You can cancel a Direct Debit at any time by simply contacting your bank or building society. Written confirmation may be required. Please also notify us.</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default DirectDebitGuarantee;